/*
 * @Description:
 * @Date: 2021-06-30 10:02:55
 */
import Vue from 'vue';
import store from '@/store/index.js';
import router from '@/router/index';
import Bi from '../page/BI-old/index.vue';

const BiConstructor = Vue.extend({ ...Bi, store, router });
let instances = new Map();

const remove = uid => {
  return () => {
    let instancesSize = instances.size;
    if (!instancesSize) {
      throw new Error('没有 xrkDialog实例');
    }
    let keys = [...instances.keys()];
    let lastKey = keys[keys.length - 1];
    let example = instances.get(uid || lastKey); // 如果没有uid则删除最后一个
    document.getElementById('app').removeChild(example.$el);
    example.$destroy();
    instances.delete(example._uid);
  };
};

const initInstance = options => {
  let instance = new BiConstructor({
    el: document.createElement('div'),
    props: {
      localQuery: {
        type: Object,
        default: () => options.localQuery
      }
    }
  });
  let { _uid } = instance;
  instances.set(_uid, instance);
  instance.remove = remove(_uid);
  return instance;
};

const biReport = function(options) {
  let instance = initInstance(options);

  for (let prop in options) {
    if (options.hasOwnProperty(prop)) {
      instance[prop] = options[prop];
    }
  }
  // 直接使用当前调用绑定父级
  if (this) {
    instance.$parent = this;
  }
  instance.$mount();
  document.getElementById('app').appendChild(instance.$el);
  Vue.nextTick(() => {
    instance.visible = true;
  });
  return instance;
};

biReport.clear = () => {
  instances.forEach(item => {
    document.getElementById('app').removeChild(item.$el);
    item.$destroy();
  });
  instances.clear();
};

biReport.remove = remove();

export default biReport;
